<template>
  <div class="nav-search-results">
    <TransitionResults>
      <ResultsTitle v-if="getMappedHits.length > 0">
        {{
          UI_ELEMENT(`search_results_subtitle_${sets ? "sets" : "products"}`) +
            ` (${getMappedHits.length})`
        }}
      </ResultsTitle>
    </TransitionResults>
    <TransitionResults group>
      <NavSearchResultsItem
        v-for="hit in getMappedHits"
        :key="hit.sys.id"
        :content="hit"
        @clicked="() => handleResultClick(hit)"
      />
    </TransitionResults>
  </div>
</template>

<script>
import { createWidgetMixin } from "vue-instantsearch"
import { connectHits } from "instantsearch.js/es/connectors"

import { mapGetters } from "vuex"

import { productTypes } from "../../store/constants"

import NavSearchResultsMixin from "./NavSearchResultsMixin"

import NavSearchResultsItem from "./NavSearchResultsItem.vue"

import "./NavSearchResults.scss"

export default {
  mixins: [
    NavSearchResultsMixin,
    createWidgetMixin({ connector: connectHits })
  ],

  props: {
    sets: Boolean
  },

  data: () => ({
    maxResults: 5 // The number of results to return for this view - used by NavSearchResultsMixin
  }),

  components: {
    NavSearchResultsItem
  },

  computed: {
    ...mapGetters("content", ["GET_PRODUCT_ENTRY"]),

    getMappedHits() {
      return this.getHits
        .map(hit => {
          const prod = this.GET_PRODUCT_ENTRY(
            hit.id,
            this.sets
              ? productTypes.SET
              : [productTypes.PRODUCT, productTypes.GIFT_CARD]
          )
          return prod ? { ...hit, ...prod } : null
        })
        .filter((product, index, array) => {
          // This filters out more than a single gift card in the search results
          return (
            product !== null &&
            array.findIndex(
              item =>
                item !== null &&
                (item.sys.id === product.sys.id ||
                  item.__typename === productTypes.GIFT_CARD)
            ) === index
          )
        })
    }
  }
}
</script>

<style lang="scss"></style>
